import React, { useState, useEffect } from 'react';
import { SafeAreaView, StyleSheet, View, FlatList } from 'react-native';
import { Text, Button, Divider } from 'react-native-elements';
import Firebase from '../components/FirebaseContext';
import { Tools } from '../utils/types/Tools';
import Renderer from '../utils/Renderer';
import ScreenActivity from '../components/ScreenActivity';
import { scale } from 'react-native-size-matters';

export default function EnrolleeFeedback(): JSX.Element {
	const firestore = Firebase.firestore();
	const [enrolleeTool, setEnrolleeTool] = useState<Tools>();
	const [failedFetch, setFailedFetch] = useState(false);
	useEffect(() => {
		firestore
			.collection('tools')
			.doc('379rCN4dUoHwdKU2Kn19')
			.get()
			.then((doc) => {
				if (doc.exists) {
					setEnrolleeTool(doc.data() as Tools);
				}
			})
			.catch(() => {
				setFailedFetch(true);
			});
	}, [firestore]);

	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
			{enrolleeTool ? (
				<View style={styles.inner}>
					<Text style={{ fontWeight: '700', marginBottom: 20, textAlign: 'center', fontSize: scale(20) }}>
						{enrolleeTool.name}
					</Text>
					<Divider />
					<FlatList
						showsVerticalScrollIndicator={false}
						alwaysBounceVertical={true}
						style={{ marginVertical: 10 }}
						data={enrolleeTool.questions}
						renderItem={({ item, index }) => (
							<Renderer
								question={item}
								index={index}
								allowNumbering={enrolleeTool.allowNumbering || true}
								beginNumberingAt={
									enrolleeTool.beginNumberingAt > 9 || enrolleeTool.beginNumberingAt < 1
										? 1
										: enrolleeTool.beginNumberingAt || 1
								}
							/>
						)}
						keyExtractor={(item) => item.content.replace(/[^\w]/gi, '')}
						ListFooterComponent={
							<Button
								title="Submit"
								buttonStyle={{ backgroundColor: '#275036', paddingVertical: 12 }}
								onPress={() => {
									// push the entire tools to saved tools
								}}
								containerStyle={{ marginBottom: 40 }}
							/>
						}
					/>
				</View>
			) : failedFetch ? (
				<View style={{ flex: 1, justifyContent: 'center' }}>
					<Text style={{ textAlign: 'center', alignSelf: 'center' }} h4>
						This form is not available
					</Text>
				</View>
			) : (
				<></>
			)}
			<ScreenActivity active={!enrolleeTool && !failedFetch} msg="Loading please wait..." />
		</SafeAreaView>
	);
}

const styles = StyleSheet.create({
	checkbox: {
		borderWidth: 0,
		backgroundColor: '#00000000',
	},
	inner: {
		padding: scale(16),
		flex: 1,
		justifyContent: 'space-around',
	},
});
